import React, {useState, useEffect,} from 'react';
import Api from '../../Api';
import Butao from '../../Components/Butao_list';
import Campo from '../../Components/Campo';
import TASelect from '../../Components/TASelectEdit';
import Header from '../../Components/Header';
import { Spinner  } from "react-awesome-spinners";
import FinderSelect from 'react-finderselect';
import { Web } from '@material-ui/icons';
import Select from 'react-select';


export default ({ListEsp, InfIdUse, InfIdConta, IdUse, IdConta, setAddList, setUsuariosContServ, UsuariosContServ,  Dados, Avisando, Fechar, Id, setAlert, setAlertTipo, MsgDesativar}) => {

const [Titulo, setTitulo] = useState("Vizualizar Treino");
const [MsgErro, setMsgErro] = useState("");
const [Loading, setLoading] = useState(false);
const [Nome, setNome] = useState("");
const [Treino, setTreino] = useState([]);
const [ListCategoria, setListCategoria] = useState([]);
const [ListExercicio, setListExercicio] = useState([]);

 useEffect(() => {
     ListCategorias()    
      }, [])

useEffect(() => {

      }, [Treino])

useEffect(() => {
  if (ListEsp && ListCategoria.length > 0) {
    setTreino([]);
    setNome("");
    PreencherFormulario();
  }
}, [ListEsp, ListCategoria]);

  
const PreencherFormulario = () => {
     setNome(ListEsp.Nome)
     setTreino(ListEsp.Treino)

}

const ListCategorias = async ()=>{
          await Api.TAListdeCatTreino(IdConta, setListCategoria, setListExercicio )
        }
         const criando = ()=>{

             if(ListEsp.IdUser === IdUse){
            if(Nome !=="" && Nome !==" " && Nome !=="  " && Nome !=="   " && Nome !=="    " && Nome !=="     " && Nome !=="      "
            && Nome !=="       " && Nome !=="        " && Nome !=="         " && Nome !=="          " 
            && Nome !=="           " ){
              if (navigator.onLine) {
                setMsgErro("")
                setLoading(true) 
                  
                 Api.TAEditarTreino(Id, InfIdUse, IdUse, IdConta, Nome, Treino, UsuariosContServ, setUsuariosContServ,  setMsgErro, setLoading, setAlertTipo, setAlert);
         
              } else {
                setAlert("Sem Internet");
                setAlertTipo("danger");
              }
            } else {
                setMsgErro("Preencha o Nome Completo do Cliente.")
            }
             } else {
                setMsgErro("O Treino só pode Ser Atualizado pelo Criador.")
            }
            
          }
               
const  EntrandoTreino = async ()=>{
         setTreino([
             
              ...Treino,
               {  
                Id: "",
                Nome: "", 
                IdCategoria: "",
                Categoria: "",
                ListExercicio:[],
                TempoAtivo: false, 
                BenefAtivo: "", 
                FazerAtivo: "", 
                MuscuAtivo: "",  
                Beneficios: "", 
                ComoFazer: "",  
                UrlTrenio: "",
                UrlMusculo: "",
                Concluido: false, 
                Serie:[{Quant:0, Concluido:false}],
    
              },
            ]);
         
        }
    const RemoverUltimoTreino = () => {
    setTreino(prevTreino => prevTreino.slice(0, -1));


    };
    
    
    const printValue4 = (key, target) => {
  const novaCategoria = target.label;
  const novaCategoriaId = target.value;

  // Filtra os exercícios da categoria escolhida
  const ListExer = ListExercicio.filter(
    (ex) => ex.Categoria === novaCategoria
  );

  // Atualiza o treino selecionado
  setTreino((prevTreino) =>
    prevTreino.map((item, i) =>
      i === key
        ? {
            ...item,
            IdCategoria: novaCategoriaId,
            Categoria: novaCategoria, // <- atualiza o nome
            ListExercicio: ListExer,  // <- atualiza os exercícios
            UrlMusculo:"",
            Id: "",                   
            Nome: "",
            TempoAtivo: false, 
            BenefAtivo: false, 
            FazerAtivo: false, 
            MuscuAtivo: "",  
            Beneficios: "", 
            ComoFazer: "",  
            UrlTrenio: "",
            UrlMusculo: "",
            Concluido: false,
            Serie:[{Quant:0, Concluido:false}],
          }
        : item
    )
  );
};





      const AddExecicio = async (dados, key)=>{
        // console.log(key)
        //  console.log(dados)
          setTreino(prevTreino =>
            prevTreino.map((item, i) =>
              i === key
                ? {
                    ...item,
                  Id: dados.Id,
                  Nome: dados.Nome, 
                  IdCategoria: dados.IdCategoria,
                  Categoria: dados.Categoria,
                  TempoAtivo: dados.TempoAtivo, 
                  BenefAtivo: dados.BenefAtivo, 
                  FazerAtivo: dados.FazerAtivo, 
                  MuscuAtivo: dados.MuscuAtivo,  
                  Beneficios: dados.Beneficios, 
                  ComoFazer: dados.ComoFazer,  
                  UrlTrenio: dados.UrlTrenio,
                  UrlMusculo: dados.UrlMusculo,
                  Serie:[{Quant:0, Concluido:false}],
                  }
                : item
            )
          );
        }

           const AdicionandoSerie = async (indexTreino)=>{
                setTreino(prevTreino => {
            return prevTreino.map((treino, idx) => {
              if (idx === indexTreino) {
                return {
                  ...treino,
                  Serie: [...treino.Serie, { Quant: 0, Concluido: false }] // adiciona nova série
                };
              }
              return treino;
            });
          });
        }
          const RemoverSerie = (indexTreino) => {
            setTreino(prevTreino => {
              return prevTreino.map((treino, idx) => {
                if (idx === indexTreino) {
                  // Remove a última série, mas garante que sempre haja pelo menos uma
                  return {
                    ...treino,
                    Serie: treino.Serie.length > 1 ? treino.Serie.slice(0, -1) : treino.Serie
                  };
                }
                return treino;
              });
            });
          };

          const alterarQuant = (indexTreino, indexSerie, value) => {
          setTreino(prevTreino => {
            return prevTreino.map((treino, tIdx) => {
              if (tIdx === indexTreino) {
                return {
                  ...treino,
                  Serie: treino.Serie.map((serie, sIdx) => {
                    if (sIdx === indexSerie) {
                      return { ...serie, Quant: value }; // atualiza a série específica
                    }
                    return serie;
                  })
                };
              }
              return treino;
            });
          });
        };

        const getCategoriaDefault = (categoriaNome) => {
        if (!categoriaNome || !ListCategoria.length) return null;
        return ListCategoria.find(cat =>
          cat.label === categoriaNome || cat.value === categoriaNome
        ) || null;
      };
        return (
            <>
<div className="content-wrapper">
                <Header 
                Titulo={Titulo}
                Avisando={Avisando}
                Fechar={Fechar}
                />
               <section className="content">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12">
            
              <div className="invoice p-3 mb-3">
              {/* title row */}
              <div className="row">
                <div className="col-12">
                  <h4>
                    <i className="fas fa-edit" /> Treino
                  </h4>
                </div>
                {/* /.col */}
              </div>
              {/* info row */}
              <address>
                    {Loading  ?
                    <>
                      <Spinner 
                      size={64}
                      color={"#5d0bf7"}
                      sizeUnit={'px'} 
                      /><br />
                      </>
                      :
                      <>
                        {Dados &&
                      <>
                    {Dados.Treinos.Btn.botão_Atualizar &&
                    <>
                    <div className="col-12">
                        <Butao 
                        style={"btn .btn-sm btn-info"}
                        titulo={"Atualizar"}
                        onClick={()=>criando()}
                        />  
                    </div><br />
                          </>
                          }
                          </>
                          }
                   
                    
                     {MsgErro !== "" &&
                    <>
                    <div class="alert alert-danger alert-dismissible">
                  
                  <h5><i class="icon fas fa-ban"></i> Alert!</h5>
                  {MsgErro}
                </div>
                   
                    </>
                    }
                    </>
                    }
                    
             <strong>Nome do Treino</strong><br />
                    <div className="input_cadatro">
                              
                              <input
                              type="text"
                              value={Nome}
                              onChange={t=>setNome(t.target.value)}
                              className="border p-2 rounded"
                              placeholder="Digite o Nome do Treino"
                            />

                            </div> 
                    <br /> 
                 <strong>Nome do Criador</strong><br />
                   <string>{ListEsp.NomeUser}</string>
                    <br /> 
                     <strong>Adiconar {Treino && Treino.length > 0 ?"e Remover":""} Exercício</strong><br />
                     <button
                      onClick={EntrandoTreino}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",    
                        backgroundColor: "#2563eb",
                        color: "#fff",
                        fontSize: "25px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      }}
                    >
                    +
                  </button>
                   {Treino && Treino.length > 0 && (
                    <>
                   <button
                      onClick={RemoverUltimoTreino}
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",
                        marginLeft:20,    
                        backgroundColor: "#cb605c",
                        color: "#fff",
                        fontSize: "25px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                      }}
                    >
                    -
                  </button>
                  </>  
                   )}            
                  </address>
              <div className="row invoice-info">
               
 
                   {Treino && Treino.length > 0 && (
                    <>
                    {Treino.map((item, key)=>(
                      <div className="col-sm-4 invoice-col">
                         <div
                        style={{
                          boxShadow: "0 -4px 6px -2px rgba(0, 0, 0, 0.3)", // sombra no topo
                          padding: "20px",
                          borderRadius: "10px",
                          backgroundColor: "#fff",
                        }}
                      > 
                    <address>
                      <strong style={{fontSize:20}}>{key+1}° Exercício </strong><br />
                     <strong>Categoria</strong><br />  
                    
                      <Select
                        value={getCategoriaDefault(item.Categoria)}                          
                        onChange={(target) => printValue4(key, target)}
                        options={ListCategoria}
                        placeholder={"Escolha a Categoria"}
                      /> 
                      {item.ListExercicio.length > 0 && (
                   <>
                      <TASelect
                       key={`TA-${key}-${item.IdCategoria ?? item.Categoria ?? 'none'}`}
                       data={item.ListExercicio}
                       Chave={key}
                       AddExecicio={AddExecicio}
                       Treino={item}
                      />
                      {item.Nome &&
                      <>

                      {item.TempoAtivo === false &&
                       <>
                      
                       <strong>Add e Remover Série:</strong><br />
                        <button
                      onClick={() => AdicionandoSerie(key)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",    
                        backgroundColor: "#2563eb",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        marginBottom:"5px"
                      }}
                    >
                    +
                  </button>
                   <button
                      onClick={() => RemoverSerie(key)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "10%",
                        border: "none",
                        outline: "none",
                        marginLeft:5,    
                        backgroundColor: "#cb605c",
                        color: "#fff",
                        fontSize: "15px",
                        cursor: "pointer",
                        boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                        marginBottom:"5px"
                      }}
                    >
                    -
                  </button><br />
                   </>
                    }
                    {item.TempoAtivo ?
                    <>
                    <strong>Tempo em Minutos:</strong><br />
                    </>
                    :
                    <>
                    <strong>Repetições:</strong><br />
                    </>
                    }
                   
                   <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "10px" }}>
                      {item.Serie.map((item1, key1)=>(
                        <>
                       
                        <div className="input_cadatro">
                                  
                                  <input
                                  type="text"
                                  value={item1.Quant}
                                  onChange={(e) => alterarQuant(key, key1, Number(e.target.value))}
                                  maxLength={2}
                                  className="border p-2 rounded"
                                  placeholder="00"
                                  size={2}
                                />

                               </div> 
                        
                        </>
                        ))}
                        </div>
                        </>
                        }
                        </>
                        )} 
                    </address>
                    </div>
                   </div>
                    ))}
                    
                    </>
                    )}
                    
              </div>
              <div className="row no-print">
              </div>
              
            
            </div> 
            </div>
            </div>
            </div>
          </section>
  
</div>

            </>
        );
}